export default {
  appTitle: 'Captin - Dev',
  apiUrl: 'https://devapi.captin.io/api',
  appEnv: 'staging',
  isDevelopment: false,
  isStaging: true,
  isProduction: false,
};
